import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
 
const roleAccess = {
  kc: ["/tracking", "/performance",],
  ebam: ["/tracking", "/performance"],
  tmt: ["/drm_tool"]
}
 
const ProtectedRoutes = () => {
 
  const { authState } = useOktaAuth();
  const location = useLocation();
  const accessiblePaths = [];
  const roles = authState?.idToken?.claims?.Roles;
 
  Object.keys(roleAccess).map((v) => {
    if(roles.some(el => el.includes(v))){
      accessiblePaths.push(...roleAccess[v]);
    }
  })
 
  const isAllowed = accessiblePaths.some(path => location?.pathname.includes(path));
 
  return isAllowed ? <Outlet /> : <Navigate to='/' />
 
}
 
export default ProtectedRoutes;